<template>
  <div>
    <div class="shopping-cart" @click="() => $router.push({ name: 'ShoppingCart' })">
      <div v-if="!appUtils.checkIsMobileAndTablet()">
        <p class="fs-14 mb-0 max-line-1">Sản phẩm/DV đã yêu cầu</p>
        <p
          class="fs-16 fw-500 txt-pri mb-0 max-line-1"
        >{{ totalPrice ? appUtils.numberFormat(totalPrice) : 0 }} đ</p>
      </div>
      <div class="relative">
        <div
          v-if="$shoppingCart.length"
          class="absolute top-0 right-0 -mt-5 -mr-4 flex bg-red-500 text-white fs-14 py-0.5 w-7 h-7 text-center rounded-full"
        >
          <span class="m-auto">{{ $shoppingCart.length }}</span>
        </div>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.2"
            d="M27 8L25.48 16.3575C25.3963 16.8183 25.1535 17.2352 24.7939 17.5353C24.4344 17.8355 23.9809 17.9999 23.5125 18H7.81875L6 8H27Z"
            fill="currentColor"
          />
          <path
            d="M27.7675 7.35875C27.6736 7.24642 27.5562 7.15607 27.4236 7.09408C27.291 7.03209 27.1464 6.99998 27 7H6.835L6.22375 3.6425C6.14003 3.18167 5.89723 2.76484 5.53767 2.46468C5.17812 2.16452 4.72462 2.00007 4.25625 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3C1 3.26522 1.10536 3.51957 1.29289 3.70711C1.48043 3.89464 1.73478 4 2 4H4.25L7.445 21.5362C7.53911 22.0563 7.76895 22.5423 8.11125 22.945C7.63881 23.3863 7.29781 23.9498 7.12607 24.573C6.95433 25.1962 6.95856 25.8549 7.13829 26.4759C7.31801 27.0968 7.66622 27.6559 8.14428 28.0911C8.62235 28.5263 9.2116 28.8205 9.8467 28.9412C10.4818 29.062 11.1379 29.0044 11.7423 28.775C12.3467 28.5456 12.8758 28.1533 13.2708 27.6416C13.6658 27.1299 13.9114 26.5187 13.9804 25.8759C14.0493 25.2332 13.9388 24.5838 13.6613 24H19.3388C19.115 24.4684 18.9993 24.981 19 25.5C19 26.1922 19.2053 26.8689 19.5899 27.4445C19.9744 28.0201 20.5211 28.4687 21.1606 28.7336C21.8001 28.9985 22.5039 29.0678 23.1828 28.9327C23.8617 28.7977 24.4854 28.4644 24.9749 27.9749C25.4644 27.4854 25.7977 26.8617 25.9327 26.1828C26.0678 25.5039 25.9985 24.8001 25.7336 24.1606C25.4687 23.5211 25.0201 22.9744 24.4445 22.5899C23.8689 22.2053 23.1922 22 22.5 22H10.3962C10.1621 22 9.93532 21.9177 9.75554 21.7677C9.57576 21.6176 9.45436 21.4092 9.4125 21.1787L9.01625 19H23.5163C24.2188 18.9999 24.8991 18.7532 25.4384 18.303C25.9777 17.8527 26.3419 17.2275 26.4675 16.5362L27.9875 8.17875C28.0132 8.0343 28.0069 7.88596 27.9688 7.74424C27.9308 7.60253 27.8621 7.47092 27.7675 7.35875ZM12 25.5C12 25.7967 11.912 26.0867 11.7472 26.3334C11.5824 26.58 11.3481 26.7723 11.074 26.8858C10.7999 26.9993 10.4983 27.0291 10.2074 26.9712C9.91639 26.9133 9.64912 26.7704 9.43934 26.5607C9.22956 26.3509 9.0867 26.0836 9.02882 25.7926C8.97094 25.5017 9.00065 25.2001 9.11418 24.926C9.22771 24.6519 9.41997 24.4176 9.66665 24.2528C9.91332 24.088 10.2033 24 10.5 24C10.8978 24 11.2794 24.158 11.5607 24.4393C11.842 24.7206 12 25.1022 12 25.5ZM24 25.5C24 25.7967 23.912 26.0867 23.7472 26.3334C23.5824 26.58 23.3481 26.7723 23.074 26.8858C22.7999 26.9993 22.4983 27.0291 22.2074 26.9712C21.9164 26.9133 21.6491 26.7704 21.4393 26.5607C21.2296 26.3509 21.0867 26.0836 21.0288 25.7926C20.9709 25.5017 21.0007 25.2001 21.1142 24.926C21.2277 24.6519 21.42 24.4176 21.6666 24.2528C21.9133 24.088 22.2033 24 22.5 24C22.8978 24 23.2794 24.158 23.5607 24.4393C23.842 24.7206 24 25.1022 24 25.5ZM24.5 16.1787C24.458 16.4098 24.3361 16.6187 24.1555 16.7689C23.975 16.919 23.7473 17.0008 23.5125 17H8.6525L7.19875 9H25.8013L24.5 16.1787Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'ShoppingCartCpn',
  props: ['products'],
  data () {
    return {
      appUtils
    }
  },
  computed: {
    totalPrice () {
      return this.$shoppingCart.reduce(
        (accum, item) => accum + item.total_amount,
        0
      )
    }
  }
}
</script>

<style scoped>
.shopping-cart {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(230, 235, 249, 1);
  height: 50px;
  width: 100%;
  border-radius: 90px;
  padding: 0px 16px 0px 16px;
  cursor: pointer;
  min-width: 240px;
  gap: 12px;
}

@media (max-width: 765px) {
  .shopping-cart {
    min-width: unset;
    padding: 0px 8px;
    border-radius: 15px;
    height: 40px;
  }
}
</style>
